class Api {
    url = 'https://cable-price-monitoring.ru/'
    
    headers = {
        'Content-Type': 'application/json',
    }

    async listenerResponce (response) {
        if(response.ok) return await response.json()
        // else if(response.status === 401 || response.status === 419) return await this.refresh()
        else {
            throw new Error(response.statusText)
        }
    }


    async login (values){        
        const response = await fetch(this.url + 'api/v2/auth/login',{
            method: 'POST',
            body: values
        })
        return await response.json()
    }

    async auth (){
        const response = await fetch(this.url + 'api/v1/users/current_user',{
            method: 'GET',
            headers: {...this.headers, 'Authorization': `Bearer ${localStorage.getItem('access_token')}`}
        })
        return await response.json()
    }

    async refresh (){
        const responce = await fetch(this.url + 'api/v2/auth/refresh',{
            method: 'POST',
            headers: {...this.headers, 'Authorization': `Bearer ${localStorage.getItem('refresh_token')}`}
        })
        const res =  await responce.json()
        if(res.access_token && res.refresh_token){
            localStorage.setItem('access_token', res.access_token)
            localStorage.setItem('refresh_token', res.refresh_token)
            return res
        }else {
            localStorage.clear()
            return null         
        }
    }

    async getCablesById ({cable, vendor}){       
        const arr = vendor.map(item => `vendor_id=${item.id}`).join('&')
        const response = await fetch(this.url + `api/v1/alias/${cable}/prices?${arr}` ,{
            method: 'GET',
            headers: {...this.headers, 'Authorization': `Bearer ${localStorage.getItem('access_token')}`}
        })
        if(response.status === 401 || response.status === 419) {
            await this.refresh()
            return await this.getCablesById ({cable, vendor})
        }
        return await this.listenerResponce(response, this.getCablesById)
    }

    async getCableTags () {
        const response = await fetch(this.url + 'api/v1/aliases/short',{
            method: 'GET',
            headers: {...this.headers, 'Authorization': `Bearer ${localStorage.getItem('access_token')}`}
        })
        if(response.status === 401 || response.status === 419) {
            await this.refresh()
            return await this.getCableTags ()
        }
        return await this.listenerResponce(response, this.getCableTags)
    }

    async getCablesTable (){
        const response = await fetch(this.url + 'api/v1/marketplaces/prices',{
            method: 'GET',
            headers: {...this.headers, 'Authorization': `Bearer ${localStorage.getItem('access_token')}`}
        })
        if(response.status === 401 || response.status === 419) {
            await this.refresh()
            return await this.getCablesTable ()
        }
        return await this.listenerResponce(response, this.getCablesTable)
    }



    async getStores (){
        const response = await fetch(this.url + 'api/v1/stores',{
            method: 'GET',
            headers: {...this.headers, 'Authorization': `Bearer ${localStorage.getItem('access_token')}`}
        })
        if(response.status === 401 || response.status === 419) {
            await this.refresh()
            return await this.getStores ()
        }
        return await this.listenerResponce(response, this.getStores)
    }

    async getVendors (){
        const response = await fetch(this.url + 'api/v1/vendors',{
            method: 'GET',
            headers: {...this.headers, 'Authorization': `Bearer ${localStorage.getItem('access_token')}`}
        })
        if(response.status === 401 || response.status === 419) {
            await this.refresh()
            return await this.getVendors ()
        }
        return await this.listenerResponce(response, this.getVendors)
    }

    async getRegions () {
        const response = await fetch(this.url + 'api/v1/locations', {
            method: 'GET',
            headers: {...this.headers, 'Authorization': `Bearer ${localStorage.getItem('access_token')}`}
        })
        if(response.status === 401 || response.status === 419) {
            await this.refresh()
            return await this.getRegions()
        }
        return await this.listenerResponce(response)
    }

}


export const api = new Api()